/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum Status {
  NotInitialized = "NotInitialized",
  Initialized = "Initialized",
  Ready = "Ready",
  Error = "Error",
  Disabled = "Disabled",
}
